export const addValueToArray = <T,>(
    arr: T[],
    index: number,
    value: T,
    immutable: boolean = true
): T[] => {
    
    // Проверка валидности индекса
    if (!Number.isInteger(index) || index < 0) {
        throw new Error("Отрицательный индекс");
    }

    if (immutable) {
        const newArr = [...arr];
        newArr[index] = value;
        return newArr;
    } else {
        arr[index] = value;
        return arr;
    }
};
